import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root',
})
export class FarmersApplicationService extends BaseService {
  constructor(private _http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this._http = _http;
  }

  postFarmersRegistrationData(data: any): Observable<any> {
    return this._http.post(
      environment.apiUrl + 'FarmerApplication/SubmitApplication',
      data
    );
  }

  getAllMiVendors(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetAllMIvenders'
    );
  }
  getAllSolarVendors(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetAllSolarVender'
    );
  }
  getPrimarySolarVendors(solarId): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetPrimarySolarVender?solarID='+solarId
    );
  }

  getPumpCapacityList(PumpContType, PumpCategory, PumpType): Observable<any> {
    return this._http.get(
      environment.apiUrl + `FarmerApplication/GetSolarPumpCapacity?PumpContType=${PumpContType}&PumpCategory=${PumpCategory}&PumpType=${PumpType}`
    );
  }

  updateFarmerSolarDetails(reqBody): Observable<any> {
    return this._http.put(
      environment.apiUrl + `FarmerApplication/UpdateFarmerSolarDetails`, reqBody
    );
  }

  getSecondarySolarVendors(solarId): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetSecondarySolarVender?solarID=' + solarId
    );
  }

  getAllTank(): Observable<any> {
    return this._http.get(environment.apiUrl + 'FarmerApplication/GetAllTank');
  }

  getTankType(): Observable<any> {
    return this._http.get(environment.apiUrl + 'FarmerApplication/GetTankType');
  }
  
  getAreaBasedOnTankType(tankType: any): Observable<any> {
    return this._http.get(environment.apiUrl + `FarmerApplication/GetAreaBasedOnTankType?TankType=${tankType}`);
  }

  getSolarMaster(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetSolarMaster'
    );
  }

  getComponentMaster(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetComponentMaster'
    );
  }
  
  getSchemeMaster(...args): Observable<any> {
    return this._http.get(`${environment.apiUrl}FarmerApplication/GetSchemeMaster?SchemeId=${args[0] ? args[0] : ''}`
    );
  }

  getFarmersLandId(farmerId): Observable<any> {
    return this._http.get(
      environment.apiUrl +
      'LandDetails/GetByFarmerID?FarmerID=' +
      farmerId
    );
  }

  getNotUsedLandsByFarmerID(farmerId: any) {
    return this._http.get<any>(`${environment.apiUrl}LandDetails/GetNotUsedLandsByFarmerID?FarmerID=${farmerId}`);
  }

  GetAllFarmerDetails(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetAllFarmerDetails'
    );
  }

  GetAllOutletDetails(villageCode: any): Observable<any> {
    // return this._http.get(
    //   `${environment.apiUrl}FarmerApplication/GetOutlatMaster?villageCode=${villageCode}`
    // );

    return this._http.post(
      environment.apiUrl + 'FarmerApplication/GetOutlatMaster',
      villageCode
    );
  }


  LetAllOutletDetails(): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}FarmerApplication/GetAllOutlatMaster`
    );
  }

  GetWorktypeMaster(): Observable<any> {
    return this._http.get(
      environment.apiUrl + 'FarmerApplication/GetWorkTypeMaster'
    );
  }

  GetFarmerDetailsByVillageCode(villageCode: string): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}FarmerApplication/GetFarmerDetailsByVillageCode/${villageCode}`
    );
  }

  GetFarmerAndLandByVillageCode(villageCode: string): Observable<any> {
    // return this._http.get(
    //   `${environment.apiUrl}FarmerApplication/GetFarmerLandByVillageCode/${villageCode}`
    // );
    return this._http.post(
      environment.apiUrl + 'FarmerApplication/GetFarmerLandByVillageCode',
      villageCode
    );
  }

  GetFarmerLandByFarmerIds(reqBody: any): Observable<any> {
    return this._http.post(
      environment.apiUrl + 'LandDetails/GetFarmerLandByFarmerID',
      reqBody
    );
  }

  getAllMIvenders(programId: string): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}FarmerApplication/GetAllMIvenders?ProgramId=${programId}`
    );
  }

  getApplicationIdsByFarmerIdForCR(farmerId: any){
    return this._http.get<any>(`${environment.apiUrl}ChangeRequest/GetApplicationIdsByFarmerIdForCR?FarmerId=${farmerId}`, { headers: this.buildHeaders() });
  }

  personalDetailsInsert_CR(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'ChangeRequest/PersonalDetailsInsert_CR', reqBody);
  }

  
  changeReqSubmitApplication(data: any): Observable<any> {
    return this._http.post(
      environment.apiUrl + 'ChangeRequest//SubmitApplication_CR',
      data
    );
  }

  getOverFlowPondMaster(Village_Code: any){
    return this._http.post(environment.apiUrl + 'FarmerApplication/GetOverFlowPondMaster', Village_Code);
  }

  getValidateUHBVNData(uhbvnAppId, mobileNo){
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetValidateUHBVNData?UHBVNAppId=${uhbvnAppId}&MobileNo=${mobileNo}`, { headers: this.buildHeaders() });
  }

  getFarmerCategory(){
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetFarmerCategory`, { headers: this.buildHeaders() });
  }
  
  getOutletByContractor(ContractorId, userId, status){
    return this._http.get<any>(`${environment.apiUrl}Vendor/GetOutletByContractor?ContractorId=${ContractorId}&UserId=${userId}&Status=${status}`, { headers: this.buildHeaders() });
  }

  getFarmerPastSubsidyByAadharNo(aadharNo){
    return this._http.get<any>(`${environment.apiUrl}OnFormMI/GetFarmerPastSubsidyByAadharNo?AadharNo=${aadharNo}`, { headers: this.buildHeaders() });
  }

  getAgreementByContractor(ContractorId, outletId, userId, status){
    return this._http.get<any>(`${environment.apiUrl}Vendor/GetAgreementByContractor?ContractorId=${ContractorId}&OutletId=${outletId}&UserId=${userId}&Status=${status}`, { headers: this.buildHeaders() });
  }

  getChunkIds(contractorId, agreementNo, outletId, userId, status){
    return this._http.get<any>(`${environment.apiUrl}Vendor/GetChunkIds?ContractorId=${contractorId}&AgreementNo=${agreementNo}&OutletId=${outletId}&UserId=${userId}&Status=${status}`, { headers: this.buildHeaders() });
  }

  submitOwnMIFarmerDetail(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'FarmerApplication/SubmitOwnMIFarmerDetail', reqBody);
  }

  uploadUHBVNFieldXENNoc(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'FarmerApplication/UploadUHBVNFieldXENNoc', reqBody);
  }

  getUHBVNData(appId){
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetUHBVNData?AppId=${appId}`, { headers: this.buildHeaders() });
  }

  getKrishiMapperData(apiUrl, reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + `External/${apiUrl}`, reqBody);
  }

  postKrishiMapperData(apiUrl, reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + `External/${apiUrl}`, reqBody);
  }
  
  getBeneficiaryToInsert(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'External/GetBeneficiaryToInsert', reqBody);
  }
  
  getBeneficiaryToInsertTransactionDetail(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'External/GetBeneficiaryToInsertTransactionDetail', reqBody);
  }
  
  getBeneficiaryGPSMasterData(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'External/GetBeneficiaryGPSMasterData', reqBody);
  }

  getBeneficiaryGeoFenceData(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'External/GetBeneficiaryGeoFenceData', reqBody);
  }

  getBeneficiaryCropDetail(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + 'External/GetBeneficiaryCropDetail', reqBody);
  }
  
  getWaterSourceNew(progName, appType){
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetWaterSourceNew?ProgramName=${progName}&ApplicantType=${appType}`, { headers: this.buildHeaders() });
  }
  
  getSchemeMasterNew(WaterSourceId, applicantType, SchemeType){
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetSchemeMasterNew?WaterSourceId=${WaterSourceId}&ApplicantType=${applicantType}&ProgType=${SchemeType}`, { headers: this.buildHeaders() });
  }

  deleteLandDetailsNew(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + `LandDetails/DeleteLandDetails_New?LandId=${reqBody?.LandId}&NetworkId=${reqBody?.NetworkId}&TerminalId=${reqBody?.TerminalId}`, {});
  }

  deleteFarmerGroupMember(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + `FarmerApplication/DeleteFarmerGroupMember`, reqBody);
  }

  deleteVendorRegComp(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + `vendor/DeleteVendorRegComp`, reqBody);
  }

  generateAadharOTPFarmer(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + `FarmerApplication/GenerateAadharOTP`, reqBody);
  }

  validateAadharOTPFarmer(reqBody: any): Observable<any> {
    return this._http.post(environment.apiUrl + `FarmerApplication/ValidateAadharOTP`, reqBody);
  }
}
